import * as React from "react";
import {useState, useEffect} from "react";
import {IUser} from "./AuthContext.component";
import {Navigate, useLocation, useNavigate} from "react-router";
import * as webHelpers from "../helpers/WebHelpers";
import DummySession from "../DummyResponse/Session.json";
import Cookies from 'js-cookie';
import { resolve } from "node:path/win32";

interface IRequestCustomerBody {
    job_number: string;
    postcode: string;
}

interface IRequestQuoteBody {
    quote_id: string;
    postcode: string;
}

interface IResponseBody {
    job_number: string;
    quote_id: string;
}

export function useAuthProvider() {
    const [user, setUser] = useState<IUser | null>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const location = useLocation();
    const navigate = useNavigate();

    let signInCustomer = async (job_number: string, postcode: string) => {
        let payload = {
            job_number: job_number,
            postcode: postcode,
        };

        return new Promise<boolean>((res, rej) => {
            let dummyPayload: IResponseBody = {
                job_number: DummySession.job_number,
                quote_id: ""
            };
            webHelpers.postAsync<IResponseBody, IRequestCustomerBody>(
                "/api/customer/authenticate",
                payload,
                //undefined, dummyPayload //Comment out if running server
            ).then(data => {
                //console.log(data)
                if (data && data.job_number) {
                    setUser({ job_number: data.job_number, quote_id: undefined });
                    res(true);
                }
                else {
                    res(false);
                }
            })
            .catch(err => {
                res(false);
            })
        })
    };

    let signInQuote = async (quote_id: string, postcode: string) => {
        let payload = {
            quote_id: quote_id,
            postcode: postcode,
        };
        
        return new Promise<boolean>((res, rej) => {
            let dummyPayload: IResponseBody = {
                job_number: DummySession.job_number,
                quote_id: DummySession.quote_id
            }
            webHelpers.postAsync<IResponseBody, IRequestQuoteBody>(
                "/api/quote/authenticate",
                payload,
                //undefined, dummyPayload //Comment out if running server
            ).then(data => {
                if (data && data.quote_id) {
                    setUser({ job_number: undefined, quote_id: data.quote_id });
                    res(true);
                }
                else {
                    res(false);
                }
            })
            .catch(err => {
                res(false);
            })
        })
    };

    let signout = () => {
        setUser(null);
    };

    React.useEffect(() => {
        let dummyPayload: IResponseBody = {
            job_number: DummySession.job_number,
            quote_id: ""
        }
        webHelpers.getAsync<IResponseBody>("/api/session",
        //undefined, dummyPayload //Comment out if running server
        )
        .then(data => {
            if (data && data.job_number) {
                setUser({ job_number: data.job_number, quote_id: undefined });
                setLoading(false);

                if (location.pathname == "/customer/signin") {
                    navigate("/customer/overview/" + data.job_number);
                }
            }
    
            if (data && data.quote_id) {
                setUser({ quote_id: data.quote_id, job_number: undefined });
                setLoading(false);

                if (location.pathname == "/quote/signin") {
                    navigate("/quote/overview/" + data.quote_id);
                }
            }

            setLoading(false);
        });
    }, []);

    return {user, loading, signInCustomer, signInQuote, signout};
}